import store from '@/store'

function beforeEnter(to, from, next) {
    try {
        const { hasPermissions } = store.getters

        if (!hasPermissions(to.meta.permissions)) {
            next('/404')
        } else {
            next()
        }
    } catch (error) {
        store.dispatch('logout')
        next('login')
    }
}

export default beforeEnter
